import { useParams } from "react-router";
import {
  TranslatorProvider,
  useTranslate,
} from "@avinet/adaptive-ui-translate";
import { Icon } from "../components/Icon";
import { LoadingOverlay } from "../components/Loading";
import useApiSurveySpecification from "../hooks/useApiSurveySpecification";
import { useBrowserLanguage } from "../hooks/useBrowserLanguage";
import useTranslations from "../hooks/useTranslations";
import FormLayout from "../layouts/FormLayout";
import Survey from "../types/Survey";
import "./SurveyCompleteView.scss";

interface SurveyCompleteViewRendererProps {
  loading: boolean;
  survey?: Survey;
}

const SurveyCompleteViewRenderer = ({
  survey,
  loading,
}: SurveyCompleteViewRendererProps) => {
  const t = useTranslate("SurveyCompleteView");

  return loading ? (
    <LoadingOverlay>{t("loading")}</LoadingOverlay>
  ) : survey ? (
    <FormLayout className={survey.layout}>
      <div className="survey-complete">
        <div className="survey-complete-img">
          <Icon name="checkmarkCircle" />
        </div>
        <h1>{t("title")}</h1>
        <p className="pre-wrap">
          {t("youMayCloseTheWindow", { surveyTitle: survey.title })}
        </p>
        <p>
          <button type="button" className="btn" onClick={() => window.close()}>
            {t("close")}
          </button>
        </p>
      </div>
    </FormLayout>
  ) : (
    <p className="error">{t("loadError")}</p>
  );
};

const SurveyCompleteView = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const { survey, loading } = useApiSurveySpecification(uuid);

  const browserLanguage = useBrowserLanguage();
  const translationLanguage = survey?.metaLanguage || browserLanguage;
  const lang = useTranslations(translationLanguage);

  return (
    <TranslatorProvider translations={lang}>
      <SurveyCompleteViewRenderer loading={loading} survey={survey} />
    </TranslatorProvider>
  );
};

export default SurveyCompleteView;
